import { Fuel, Gauge, Thermometer, Route, Droplets, Zap } from "lucide-react";

// Catalogue des données CAN (bus véhicule) : libellé, unité, logo (icône Lucide).
export const CAN_FIELDS = {
  fuel_pct: { label: "Carburant", unit: "%", Icon: Fuel },
  rpm: { label: "Régime moteur", unit: "tr/min", Icon: Gauge },
  coolant_temp: { label: "Température", unit: "°C", Icon: Thermometer },
  total_mileage_km: { label: "Km total (CAN)", unit: "km", Icon: Route },
  fuel_used_l: { label: "Carb. consommé", unit: "L", Icon: Droplets },
  fuel_l: { label: "Carburant (L)", unit: "L", Icon: Fuel },
  can_speed: { label: "Vitesse CAN", unit: "km/h", Icon: Gauge },
  throttle: { label: "Accélérateur", unit: "%", Icon: Zap },
};

export const CAN_ORDER = ["fuel_pct", "rpm", "coolant_temp", "total_mileage_km", "fuel_used_l", "fuel_l", "can_speed", "throttle"];

// Retourne les champs CAN réellement présents (valeur != null), dans l'ordre, avec métadonnées.
export const canEntries = (can) =>
  CAN_ORDER.filter((k) => can && can[k] != null).map((k) => ({ key: k, value: can[k], ...CAN_FIELDS[k] }));
